import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProfileType } from 'src/app/constants/profile-type';
import { DataTableRequest } from 'src/app/models/datatable-request';
import { GeneralOption } from 'src/app/models/general-option.t';
import { User } from 'src/app/models/user';
import { ApplicationService } from 'src/app/services/application.service';
import { TokenStorageService } from 'src/app/services/token-storage/token-storage.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-alarm-pegawai',
  templateUrl: './alarm-pegawai.component.html',
  styleUrls: ['./alarm-pegawai.component.css']
})
export class AlarmPegawaiComponent implements OnInit, OnDestroy {
  @ViewChild('paginator') paginator: MatPaginator | undefined;
  dataSource: User[] = [];
  baseColumns: string[] = [
    'username',
    'name',
    'substansi',
  ];
  displayedColumns: string[] = [
    ...this.baseColumns,
  ];
  page = 0;
  searchTerm = '';
  length = 0;
  pageSize = 20;
  pageSizeOptions: number[] = [20, 50, 100];
  pageEvent: PageEvent | undefined;

  @ViewChild(MatTable)
  table!: MatTable<User>;
  isLoading = false;
  onDestroy$ = new Subject<void>();
  type = ProfileType.BUP;

  types: GeneralOption[] = [
    {
      id: ProfileType.BUP,
      name: 'BUP',
    },
    {
      id: ProfileType.KGB,
      name: 'KGB',
    },
    {
      id: ProfileType.GOLONGAN,
      name: 'KENPA',
    },
  ];

  constructor(
    public dialog: MatDialog,
    public tokenStorageService: TokenStorageService,
    private userService: UserService,
    private applicationService: ApplicationService,
  ) { }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnInit(): void {
    this.reload();

    this.applicationService.unlockScreen$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.reload();
      });
  }

  search() {
    this.page = 0;
    this.paginator?.firstPage();
    this.length = 0;

    this.reload();
  }

  reload(event?: PageEvent) {
    let dateCol = '';
    if (this.type == ProfileType.BUP) {
      dateCol = 'bup';
    }
    else if (this.type == ProfileType.GOLONGAN) {
      dateCol = 'kenpa';
    }
    else if (this.type == ProfileType.KGB) {
      dateCol = 'kgb';
    }
    this.displayedColumns = [
      ...this.baseColumns,
      dateCol,
    ]
    const payload: DataTableRequest = {
      page: event ? event.pageIndex : this.page,
      dataPerPage: event ? event.pageSize : this.pageSize,
      searchTerm: this.searchTerm,
      typeId: this.type,
    };
    this.getUserList(payload);
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput
        .split(',')
        .map((str) => +str);
    }
  }

  private getUserList(payload: DataTableRequest) {
    this.isLoading = true;
    this.userService.getAlarmUsers(payload).subscribe((response) => {
      this.table.renderRows();
      this.dataSource = response.users;
      this.length = response.total;
      this.page = response.page;
      this.isLoading = false;
    });
  }
}
